import { useState, useEffect } from 'react';
import axios from 'axios';
import { MousePointerClick, Users, Briefcase, DollarSign } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

const PostPerformance = ({ postId, token }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!token || !postId) return;
    const load = async () => {
      try {
        const res = await axios.get(`${API}/business/post-performance/${postId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setData(res.data);
      } catch { /* silent */ }
    };
    load();
  }, [token, postId]);

  if (!data || data.salespeople.length === 0) return null;

  return (
    <div className="mt-4 rounded-lg border border-zinc-800 bg-brand-bg p-4" data-testid="post-performance">
      <div className="text-xs text-zinc-500 uppercase tracking-wider mb-3">Salesperson Performance</div>
      <div className="space-y-2">
        {data.salespeople.map((sp) => (
          <div key={sp.salesperson_id} className="flex items-center gap-3 rounded-lg bg-brand-surface border border-zinc-800/60 px-3 py-2" data-testid={`sp-perf-${sp.salesperson_id}`}>
            {sp.salesperson_avatar ? (
              <img src={sp.salesperson_avatar} alt={sp.salesperson_name} className="w-7 h-7 rounded-full object-cover border border-zinc-700" />
            ) : (
              <div className="w-7 h-7 rounded-full bg-brand-gold/20 flex items-center justify-center text-brand-gold text-xs font-bold">
                {sp.salesperson_name?.charAt(0)?.toUpperCase()}
              </div>
            )}
            <div className="flex-1 min-w-0">
              <div className="text-xs font-medium text-brand-text truncate">{sp.salesperson_name}</div>
            </div>
            <div className="flex items-center gap-4 text-[10px] text-zinc-400 flex-shrink-0">
              <span className="flex items-center gap-1" title="Clicks">
                <MousePointerClick className="w-3 h-3 text-blue-400" />{sp.clicks}
              </span>
              <span className="flex items-center gap-1" title="Demos">
                <Users className="w-3 h-3 text-purple-400" />{sp.demos}
              </span>
              <span className="flex items-center gap-1" title="Deals Closed">
                <Briefcase className="w-3 h-3 text-green-400" />{sp.closed_won}
              </span>
              <span className="flex items-center gap-1 font-medium text-brand-gold" title="Revenue">
                <DollarSign className="w-3 h-3" />${sp.revenue.toLocaleString()}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostPerformance;
